export default __webpack_public_path__ + "static/media/onboarding-graphics-maker.3f11e68c.png";